import cn from 'classnames';
import styles from './login.module.scss';
import React, { Component, useState, useEffect, useCallback, useRef } from 'react';
import { useMount, useUnmount } from 'react-use';
import { connect } from 'react-redux';
import {
  Form,
  Input,
  Upload,
  Button,
  Icon,
  message,
  Col,
  Row,
  Statistic,
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import * as apis from '@/apis';
import * as services from '@/models/tenants/services'
import * as actions from '@/models/tenants/actions';
import { checkCaptcha } from 'models/tenants/services';
const showRegister = () => localStorage.getItem(`xb_${process.env.APP_MODE}_token`) && localStorage.hasOwnProperty('next_to_register');
const { Countdown } = Statistic;
@connect()
@Form.create()
class RegisterModal extends Component {
  state = {
    loading: false,
    tab: 1,
    liked: true,
  };
  render() {
    const formItemLayout = {
      labelCol: { span: 10 },
      wrapperCol: { span: 24 },
      labelAlign: 'left'
    };
    const deadline = Date.now() + 1000 * 60; // Moment is also OK
    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">上传</div>
      </div>
    );

    const checkCaptcha = () => {
      let tel = getFieldValue('contact_tel');
      let captcha = getFieldValue('captcha');
      services.checkCaptcha({ mobile: tel, type: 'register', captcha: captcha })
        .then((result) => {
          const { dispatch } = this.props;
          this.props.form.validateFields((err, values) => {
            if (err) {
              return console.error(err);
            }
            if (localStorage.hasOwnProperty('xb_invite_code') && localStorage.getItem(`xb_invite_code`) && localStorage.getItem(`xb_invite_code`) != "" && localStorage.getItem(`xb_invite_code`) != null && localStorage.getItem(`xb_invite_code`) != undefined) {
              values.invite_code = localStorage.getItem(`xb_invite_code`)
            }
            console.log("values", values)
            dispatch(actions.registerTenant(values));
          });
        })
        .catch((err) => {
          message.error(err?.message || '验证码错误');
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    };
    const sendCaptcha = () => {
      let tel = getFieldValue('contact_tel');
      if (!tel) {
        message.error('请填写负责人电话');
        return
      }
      this.setState({ loading: true });
      services.sendCaptcha({ mobile: tel, type: 'register' })
        .then((result) => {
          this.setState({ liked: false });
        })
        .catch((err) => {
          this.setState({ liked: true });
          message.error(err?.message || '发送短信验证码失败');
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    };
    const onFinish = () => {
      this.setState({ liked: true });
    };
    const handleSubmit = (e) => {
      e.preventDefault();
      // checkCaptcha()
      const { dispatch } = this.props;
      this.props.form.validateFields((err, values) => {
        if (err) {
          return console.error(err);
        }
        if (localStorage.hasOwnProperty('xb_invite_code') && localStorage.getItem(`xb_invite_code`) && localStorage.getItem(`xb_invite_code`) != "" && localStorage.getItem(`xb_invite_code`) != null && localStorage.getItem(`xb_invite_code`) != undefined) {
          values.invite_code = localStorage.getItem(`xb_invite_code`)
        }
        console.log("values", values)
        dispatch(actions.registerTenant(values));
      });
    };
    //后退
    const backHomePage = () => {
      localStorage.removeItem(`xb_${process.env.APP_MODE}_token`);
      localStorage.removeItem('next_to_register');
      window.location.reload();
    };
    const onUploadStart = (file) => {
      this.setState({ loading: true });
    };
    const { getFieldDecorator, validateFields, getFieldValue } = this.props.form;
    //上传
    const customRequest = (info) => {
      const { file, filename: type } = info;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('type', 'tenant-' + type);

      apis.uploadFile(formData)
        .then((response) => {
          this.setState({ loading: false });
          if (type == 'logo') {
            this.props.form.setFieldsValue({
              logo:
                response.url +
                '?x-oss-process=image/resize,m_fill,h_320,w_320/format,jpg',
            });
          }
          if (type == 'licence') {
            this.props.form.setFieldsValue({
              licence:
                response.url +
                '?x-oss-process=image/resize,m_fill,h_320,w_320/format,jpg',
            });
          }
        })
        .catch((err) => {
          this.setState({ loading: false });
          message.error(err?.message || '图片上传失败');
          console.error('onError', err);
        });

      return {
        abort() {
          console.log('upload progress is aborted.');
        },
      };
    };
    return (
      <Form onSubmit={handleSubmit}>
        <div className={styles.wrap}>
          <div>
            <Form.Item
              {...formItemLayout}
              label="企业名称"
              extra="必须与工商注册号一致"
              required style={{ marginBottom: "0px" }}
            >
              {getFieldDecorator('name', {
                rules: [
                  {
                    required: true,
                    message: '请输入企业完整名称',
                  },
                ],
              })(
                <Input max={10} autoFocus placeholder="请输入企业完整名称" />
              )}
            </Form.Item>
            <Form.Item {...formItemLayout} label="营业执照税号" style={{ marginBottom: "0px" }}>
              {getFieldDecorator('tax_no', {
                rules: [
                  {
                    required: false,
                    message: '请输入营业执照税号',
                  },
                ],
              })(
                <Input placeholder="请输入营业执照税号" />
              )}
            </Form.Item>
            <Form.Item {...formItemLayout} label="负责人电话" required className={styles.item}>
              {getFieldDecorator('contact_tel', {
                rules: [
                  {
                    required: true,
                    message: '请输入负责人电话',
                  },
                ],
              })(
                <Input name="contact_tel" placeholder="请输入负责人电话" />
              )}
            </Form.Item>
            {/* <Form.Item {...formItemLayout} label="短信验证码" required className={styles.item}>
              {getFieldDecorator('captcha', {
                rules: [
                  {
                    required: true,
                    message: '请输入短信验证码',
                  },
                ],
              })(
                <Input
                  suffix={
                    <div>
                      {this.state.liked ? (
                        <Button
                          onClick={() => sendCaptcha()}//点击此按钮获取验证码
                        >获取验证码
                        </Button>
                      ) : (
                        <Countdown valueStyle={{ color: '#3f8600', fontSize: "14px" }} value={deadline} onFinish={onFinish} format='ss秒后失效'></Countdown>
                      )}
                    </div>
                  } />
              )}
            </Form.Item> */}
            <Form.Item {...formItemLayout} label="技术支持电话" required className={styles.item}>
              {getFieldDecorator('tech_tel', {
                rules: [
                  {
                    required: true,
                    message: '请输入技术支持电话',
                  },
                ],
              })(
                <Input placeholder="多个技术支持电话空格分隔" />
              )}
            </Form.Item>
          </div>
          <div>

            <Form.Item {...formItemLayout} label="负责人" style={{ marginBottom: "0px" }}>
              {getFieldDecorator('contact_name', {
                rules: [
                  {
                    required: false,
                    message: '请输入负责人姓名',
                  },
                ],
              })(
                <Input placeholder="请输入负责人姓名" />
              )}
            </Form.Item>
            <Form.Item {...formItemLayout} label="财务负责人电话" className={styles.item}>
              {getFieldDecorator('finance_tel', {
                rules: [
                  {
                    required: false,
                    message: '请输入财务负责人电话',
                  },
                ],
              })(
                <Input placeholder="请输入财务负责人电话" />
              )}
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="LOGO"
              extra="请上传 320x320px 的图片" className={styles.item}
            >{getFieldDecorator('logo', {
              rules: [
                {
                  required: false,
                  message: '请上传LOGO',
                },
              ],
            })(
              <Upload
                accept=".png, .jpg, .jpeg"
                multiple={false}
                name="logo"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                onStart={onUploadStart}
                customRequest={customRequest}
              >
                {getFieldValue('logo') ? (
                  <img
                    src={getFieldValue('logo')}
                    width="120"
                    alt="logo"
                  />
                ) : (
                  uploadButton
                )}
              </Upload>)}
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="营业执照"
              extra="请上传 560x320px 的图片"
            >{getFieldDecorator('licence', {
              rules: [
                {
                  required: false,
                  message: '请上传营业执照',
                },
              ],
            })(
              <Upload
                accept=".png, .jpg, .jpeg"
                multiple={false}
                name="licence"
                listType="picture-card"
                className="licence-uploader"
                showUploadList={false}
                onStart={onUploadStart}
                customRequest={customRequest}
              > {getFieldValue('licence') ? (
                <img
                  src={getFieldValue('licence')}
                  width="120"
                  alt="licence"
                />
              ) : (
                uploadButton
              )}
              </Upload>)}
            </Form.Item>
            <div className={styles.footer}>
              <Button block type="primary" htmlType="submit" size="large">
                立刻开店
              </Button>
              <Button onClick={backHomePage} type="link" style={{ color: "black" }}><u>返回首页</u></Button>
            </div>
          </div>
        </div>
      </Form>);
  }
}

function getRedirectUrl() {
  const ROLE = process.env.APP_MODE === 'tenant' ? 'staff' : 'manager';
  const FINAL_REDIRECT_URL = encodeURIComponent(
    `https://${process.env.APP_MODE}.xiaobingsubang.com/qr_connect_callback_frame`
  );
  const AUTH_REDIRECT_URL = encodeURIComponent(
    `https://api.xiaobingsubang.com/auth/wechat/callback?open=1&r=${ROLE}&redirect=${FINAL_REDIRECT_URL}`
  );

  return AUTH_REDIRECT_URL;
}

// 扫码登陆
const ScanCodeLogin = (props) => {
  const { subscribe } = props

  const tknCallbackListener = useCallback((event) => {
    try {
      const [key, token] = event.data.split(':');
      if (
        event.origin === `https://${process.env.APP_MODE}.xiaobingsubang.com` &&
        key === 'tkn' &&
        token
      ) {
        localStorage.setItem(`xb_${process.env.APP_MODE}_token`, token);
        window.location.reload();
      }
    } catch (e) { }
  }, []);

  const initWxLogin = () => {
    window.addEventListener('message', tknCallbackListener, false);
    let url = getRedirectUrl();
    const requestId = process.env.APP_MODE + Math.random().toString(36).slice(-8);
    new window.WxLogin({
      self_redirect: true,
      id: 'login_container',
      appid: 'wx0ed51ad5722614d4',
      scope: 'snsapi_login',
      redirect_uri: url,
      state: requestId,
      style: 'black',
      href:
        (process.env.PUBLIC_URL || window.location.origin) +
        '/login_frame_overwrite.css',
    });
  }

  const destroyWxLogin = () => {
    window.removeEventListener('message', tknCallbackListener, false);
  }

  useMount(async () => {
    initWxLogin()
  });

  useUnmount(async () => {
    destroyWxLogin()
  });

  return (
    <div className={styles.codewrap}>
      <div className={styles.codebox}>
        {
          subscribe ? (
            <div id="login_container" className={styles.code}>
            </div>
          ) : (

            <div style={{ textAlign: 'center' }}>
              <img src={process.env.PUBLIC_URL + '/' + 'qrcode_for_gh_8_8.jpg'}></img>
            </div>
          )
        }
      </div>
      <div className={styles.tips}>
        {subscribe ? '打开微信扫一扫登录' : (<h3 style={{ color: "red" }}>为了确保会员功能正常运行，新用户请先关注公众号，再进行登陆</h3>)}
        <br />
      </div>
    </div>
  )
}
// 关注公众号
const SubscribeWeixin = (props) => {
  const { subscribe } = props
  useMount(async () => {
  });
  useUnmount(async () => {
  });

  return (
    <div className={styles.codewrap}>
      <div className={styles.codebox}>
        <div style={{ textAlign: 'center' }}>
          <img src={process.env.PUBLIC_URL + '/' + 'qrcode_for_gh_8_8.jpg'}></img>
        </div>
      </div>
      <div>
        <a onClick={() => {
          localStorage.removeItem(`xb_${process.env.APP_MODE}_token`);
          localStorage.removeItem('next_to_register');
          window.location.reload();
        }}>我已关注</a>
      </div>
      <div className={styles.tips}>
        <h3 style={{ color: "red" }}>为了确保会员功能正常运行，新用户请先关注公众号，再进行登陆</h3>
      </div>
    </div>
  )
}
// 账号登陆
const AccountLogin = connect()(Form.create()((props) => {
  const { subscribe, form, navChange } = props
  const { getFieldDecorator } = form;

  const handleSubmit = (e) => {
    e.preventDefault();
    form.validateFields((err, values) => {

      if (err) {
        console.log('验证失败', err);
        return false
      }
      const ROLE = process.env.APP_MODE === 'tenant' ? 'staff' : 'manager';
      apis.authLogin({ ...values, r: ROLE }).then(res => {
        localStorage.setItem(`xb_${process.env.APP_MODE}_token`, res.token);
        window.location.reload();
      }).catch(err => {
        message.error(err?.message || '登陆失败');
      })
    });
  };
  useMount(async () => {

  });
  useUnmount(async () => {

  });
  return (
    <div className={styles.accountwrap}>
      <div className={styles.accountbox}>
        <Form onSubmit={handleSubmit} >
          <Form.Item>
            {getFieldDecorator('username', {
              rules: [{ required: true, message: '请输入注册手机号' }],
            })(
              <Input
                size="large"
                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="请输入注册手机号"
              />,
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('password', {
              rules: [{ required: true, message: '请输入登录密码' }],
            })(
              <Input
                size="large"
                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                type="password"
                placeholder="请输入登录密码"
              />,
            )}
          </Form.Item>
          <Form.Item>
            <Button block size="large" shape="round" type="primary" htmlType="submit" >
              登陆
            </Button>
          </Form.Item>
          <Row type="flex" gutter={[16, 16]} justify="space-between">
            <Col>
              <a style={{ color: '#333' }} onClick={() => { navChange(3) }}>忘记密码</a>
            </Col>
            <Col>
              {process.env.APP_MODE !== 'manager' && <a style={{ color: '#333' }} onClick={() => { navChange(4) }}>注册账号</a>}
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  )
}))
// 忘记密码
const ForgotPassword = connect()(Form.create()((props) => {
  const { subscribe, form, navChange } = props
  const { getFieldDecorator } = form;

  let timer = useRef() //验证码定时器
  const [second, setSecond] = useState(60) //倒计时秒数
  const [btnDisabled, setBtnDisabled] = useState(false) //按钮是否可点击，false可点击

  const handleSubmit = (e) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (err) {
        console.log('验证失败', err);
        return false
      }
      apis.forgetPass({ ...values }).then(res => {
        if (res.success === 1) {
          message.success('修改成功');
          form.resetFields()
        } else {
          message.error('修改失败');
        }
      }).catch(err => {
        message.error(err?.message || '修改失败');
      })
    });
  };
  // 发送验证码，开启倒计时
  const sendCode = () => {
    form.validateFields(['mobile'], (err, values) => {
      console.log(err, values);
      if (err) {
        return false
      }
      const { mobile } = values
      services.sendCaptcha({ mobile: mobile, type: 'forget_password' })
        .then((result) => {
          message.success('验证码发送成功');
          // 倒计时递减
          timer.current = setInterval(() => setSecond((pre) => pre - 1), 1000)
          setBtnDisabled(true)
        })
        .catch((err) => {
          message.error(err?.message || '发送短信验证码失败');
        })
        .finally(() => {
        });
    })
  }
  const initCode = () => {
    clearInterval(timer.current)
    setBtnDisabled(false)
    setSecond(60)
  }
  // 初始化时清除定时器
  useEffect(() => {
    initCode()
    return () => {
      initCode()
    }
  }, [])

  // 监听秒数的变动
  useEffect(() => {
    if (second > 0 && second < 60) {
    } else {
      // 定时器超过时间后，可以重新发送验证码
      initCode()
    }
  }, [second])

  return (
    <div className={styles.accountwrap}>
      <div className={styles.accountbox}>
        <Form onSubmit={handleSubmit} >
          <Form.Item>
            {getFieldDecorator('mobile', {
              rules: [{ required: true, message: '请输入注册手机号' }],
            })(
              <Input
                size="large"
                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="请输入注册手机号"
              />,
            )}
          </Form.Item>
          <Form.Item>
            <Row gutter={8}>
              <Col span={16}>
                {getFieldDecorator('captcha', {
                  rules: [{ required: true, message: '请输入验证码' }],
                })(<Input size="large" prefix={<Icon type="safety-certificate" theme="filled" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="请输入验证码" />)}
              </Col>
              <Col span={8}>
                <Button type="link" disabled={btnDisabled} onClick={() => { sendCode() }}>
                  {!btnDisabled ? '获取验证码' : `${second}s后重发`}
                </Button>
              </Col>
            </Row>
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('password', {
              rules: [{ required: true, message: '请输入新的8位字母数字组合密码' }],
            })(
              <Input
                size="large"
                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                type="password"
                autoComplete="new-password"
                placeholder="请输入新的8位字母数字组合密码"
              />,
            )}
          </Form.Item>
          <Form.Item>
            <Button block size="large" shape="round" type="primary" htmlType="submit" >
              确定
            </Button>
          </Form.Item>
          <Row type="flex" gutter={[16, 16]} justify="space-between">
            <Col>
              <a style={{ color: '#333' }} onClick={() => { navChange(1) }}>账号登录</a>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  )
}))
// 客服账号注册
const ManagerAccountRegister = connect()(Form.create()((props) => {
  const { subscribe, form, navChange } = props
  const { getFieldDecorator } = form;

  const handleSubmit = (e) => {
    e.preventDefault();
    form.validateFields((err, values) => {

      if (err) {
        console.log('验证失败', err);
        return false
      }
      // const ROLE = process.env.APP_MODE === 'tenant' ? 'staff' : 'manager';
      // apis.authLogin({ ...values, r: ROLE }).then(res => {
      //   localStorage.setItem(`xb_${process.env.APP_MODE}_token`, res.token);
      //   window.location.reload();
      // }).catch(err => {
      //   message.error(err?.message || '登陆失败');
      // })
    });
  };
  useMount(async () => {

  });
  useUnmount(async () => {

  });
  return (
    <div className={styles.accountwrap}>
      <div className={styles.accountbox}>
        <Form onSubmit={handleSubmit} >
          <Form.Item>
            {getFieldDecorator('username', {
              rules: [{ required: true, message: '请输入注册手机号' }],
            })(
              <Input
                size="large"
                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="请输入注册手机号"
              />,
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('password', {
              rules: [{ required: true, message: '请输入新的8位字母数字组合密码' }],
            })(
              <Input
                size="large"
                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                type="password"
                autoComplete="new-password"
                placeholder="请输入新的8位字母数字组合密码"
              />,
            )}
          </Form.Item>
          <Form.Item>
            <Row gutter={8}>
              <Col span={16}>
                {getFieldDecorator('captcha', {
                  rules: [{ required: true, message: '请输入验证码' }],
                })(<Input size="large" prefix={<Icon type="safety-certificate" theme="filled" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="请输入验证码" />)}
              </Col>
              <Col span={8}>
                <Button type="link">获取验证码</Button>
              </Col>
            </Row>
          </Form.Item>
          <Form.Item>
            <Button block size="large" shape="round" type="primary" htmlType="submit" >
              注册
            </Button>
          </Form.Item>
          <Row type="flex" gutter={[16, 16]} justify="space-between">
            <Col>
              <a style={{ color: '#333' }} onClick={() => { navChange(1) }}>账号登录</a>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  )
}))
// 企业账号注册
const TenantAccountRegister = connect()(Form.create()((props) => {
  const { subscribe, form, navChange } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;

  let timer = useRef() //验证码定时器
  const [second, setSecond] = useState(60) //倒计时秒数
  const [btnDisabled, setBtnDisabled] = useState(false) //按钮是否可点击，false可点击
  const [registerType, setRegisterType] = useState(1)

   // 添加获取 URL 参数的逻辑
   useMount(async () => {
    // 获取 URL 参数
    const urlParams = new URLSearchParams(window.location.search);
    const refercode = urlParams.get('refercode');
    
    // 如果存在 refercode，则设置到邀请码输入框
    if (refercode) {
      setFieldsValue({
        invite_code: refercode
      });
    }
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (err) {
        console.log('验证失败', err);
        return false
      }
      if (registerType == 1) {
        services.tenantsRegister(values).then(res => {
          if (res.success === 1 && res.token) {
            localStorage.setItem(`xb_${process.env.APP_MODE}_token`, res.token);
            localStorage.setItem('xb_invite_code', values.invite_code)
            window.location.reload();
          }
        }).catch(err => {
          message.error(err?.message || '注册失败');
        })
      } else if (registerType == 2) {
        services.tenantsStaffRegister(values).then(res => {
          if (res.success === 1 && res.token) {
            localStorage.setItem(`xb_${process.env.APP_MODE}_token`, res.token);
            window.location.reload();
          }
        }).catch(err => {
          message.error(err?.message || '注册失败');
        })
      }
    });
  };
  // 发送验证码，开启倒计时
  const sendCode = () => {
    form.validateFields(['mobile'], (err, values) => {
      console.log(err, values);
      if (err) {
        return false
      }
      const { mobile } = values
      services.sendCaptcha({ mobile: mobile, type: 'register_company' })
        .then((result) => {
          message.success('验证码发送成功');
          // 倒计时递减
          timer.current = setInterval(() => setSecond((pre) => pre - 1), 1000)
          setBtnDisabled(true)
        })
        .catch((err) => {
          message.error(err?.message || '发送短信验证码失败');
        })
        .finally(() => {
        });
    })
  }
  const initCode = () => {
    clearInterval(timer.current)
    setBtnDisabled(false)
    setSecond(60)
  }
  // 初始化时清除定时器
  useEffect(() => {
    initCode()
    return () => {
      initCode()
    }
  }, [])

  // 监听秒数的变动
  useEffect(() => {
    if (second > 0 && second < 60) {
    } else {
      // 定时器超过时间后，可以重新发送验证码
      initCode()
    }
  }, [second])

  return (
    <div className={styles.tenantaccountwrap}>
      <div className={styles.tabs}>
        <div className={cn(styles.tabitem, registerType == 1 ? styles.active : '')}
          onClick={() => {
            initCode()
            form.resetFields()
            setRegisterType(1)
          }}
        >企业注册</div>
        <div className={cn(styles.tabitem, registerType == 2 ? styles.active : '')}
          onClick={() => {
            initCode()
            form.resetFields()
            setRegisterType(2)
          }}
        >员工注册</div>
      </div>
      <div className={styles.accountbox}>
        <Form onSubmit={handleSubmit} >
          <Form.Item>
            {getFieldDecorator('mobile', {
              rules: [
                { required: true, message: '请输入注册手机号' },
                { pattern: /^[1]([3-9])[0-9]{9}$/, message: '请输入正确手机号' }
              ],
            })(
              <Input
                size="large"
                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="请输入注册手机号"
              />,
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('password', {
              rules: [{ required: true, message: '请输入新的8位字母数字组合密码' }],
            })(
              <Input
                size="large"
                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                type="password"
                autoComplete="new-password"
                placeholder="请输入新的8位字母数字组合密码"
              />,
            )}
          </Form.Item>
          <Form.Item>
            <Row gutter={8}>
              <Col span={16}>
                {getFieldDecorator('captcha', {
                  rules: [{ required: true, message: '请输入验证码' }],
                })(<Input size="large" prefix={<Icon type="safety-certificate" theme="filled" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="请输入验证码" />)}
              </Col>
              <Col span={8}>
                <Button type="link" disabled={btnDisabled} onClick={() => { sendCode() }}>
                  {!btnDisabled ? '获取验证码' : `${second}s后重发`}
                </Button>
              </Col>
            </Row>
          </Form.Item>
          {registerType == 1 && <Form.Item>
            <Row gutter={8}>
              <Col span={16}>
                {getFieldDecorator('invite_code', {
                  // rules: [{ required: true, message: '请输入邀请码' }],
                })(<Input size="large"
                  prefix={<Icon type="project" theme="filled" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  placeholder="请输入邀请码"
                />)}
              </Col>
              <Col span={8}>
                <span style={{ marginLeft: 10,fontSize: 12 }}>邀请码（非必填）</span>
              </Col>
            </Row>
          </Form.Item>}
          {registerType == 2 && <Form.Item>
            {getFieldDecorator('tenant_no', {
              rules: [{ required: true, message: '请输入所在企业企业码' }],
            })(<Input size="large"
              prefix={<Icon type="project" theme="filled" style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder="请输入所在企业企业码"
            />)}
          </Form.Item>}
          <Form.Item>
            <Button block size="large" shape="round" type="primary" htmlType="submit" >
              注册
            </Button>
          </Form.Item>
          <Row type="flex" gutter={[16, 16]} justify="space-between">
            <Col>
              <a style={{ color: '#333' }} onClick={() => { navChange(1) }}>账号登录</a>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  )
}))

export default (props) => {
  const { subscribe } = props
  console.log(props)
  const [showType, setShowType] = useState(1) // 账号登陆：1 扫描登陆：2 忘记密码：3 注册：4 关注公众号：5

  const getTitle = () => {
    let str = `${process.env.APP_MODE === 'manager' ? '客服' : ''}账号登陆`
    if (showType == 2) {
      str = '扫码登陆'
    } else if (showType == 3) {
      str = '忘记密码'
    } else if (showType == 4) {
      str = `${process.env.APP_MODE === 'manager' ? '客服' : ''}账号注册`
    } else if (showType == 5) {
      str = `关注公众号`
    }
    return str
  }
  const getBtnImg = () => {
    let str = ''
    if (showType == 1) {
      str = '/images/login-type-code.png'
    } else if (showType == 2) {
      str = '/images/login-type-pass.png'
    }
    return str
  }

  useMount(async () => {
    if (!subscribe) {
      // setShowType(5)
    }
  });
  useUnmount(async () => {

  });

  return (
    <div className={cn(styles.login, styles[process.env.APP_MODE])}>
      <div className={styles.logo}></div>
      <img
        className={styles.cover}
        alt=""
        src="/images/login-illustration.png"
      />
      {/* <img
        className={styles.cover}
        alt=""
        src={
          process.env.PUBLIC_URL +
          (process.env.APP_MODE === 'tenant'
            ? '/illustration-11.svg'
            : '/illustration-12.svg')
        }
      /> */}
      <div className={styles.qrcode}>
        {!showRegister() &&
          (
            <div>
              <div className={styles.title}>
                {process.env.APP_MODE === 'tenant' ? '小兵速帮企业后台' : '小兵速帮管理后台'}
                {/* {process.env.APP_MODE === 'tenant' ? '企业注册/登录' : '客服登录'}
                {process.env.APP_MODE === 'tenant' && (<h6>(新企业需先扫码再完成注册)</h6>)} */}
              </div>

              <div className={styles.loginwrap}>
                {
                  (process.env.APP_MODE === 'tenant' && showType == 4) ?
                    '' :
                    <div className={styles.logintitle}>{getTitle()}</div>
                }

                {
                  getBtnImg() && <img className={styles.logintype} src={getBtnImg()}
                    onClick={() => {
                      setShowType(showType == 1 ? 2 : 1)
                    }}
                  />
                }

                {showType == 1 && <AccountLogin {...props} navChange={(type) => { setShowType(type) }} />}
                {showType == 2 && <ScanCodeLogin {...props} />}
                {showType == 3 && <ForgotPassword {...props} navChange={(type) => { setShowType(type) }} />}
                {showType == 4 && (<>{
                  process.env.APP_MODE === 'tenant' ?
                    (<TenantAccountRegister {...props} navChange={(type) => { setShowType(type) }} />) :
                    (<ManagerAccountRegister {...props} navChange={(type) => { setShowType(type) }} />)}
                </>)
                }
                {showType == 5 && <SubscribeWeixin {...props} />}

              </div>
            </div>
          )}

        {showRegister() && (
          <div>
            <div className={styles.title}>
              完善企业信息
            </div>
            <div className={styles.registerModalWrap}>
              <RegisterModal></RegisterModal>
            </div>
          </div>
        )}
      </div>
      {/* <div className={styles.copyright}>
        {new Date().getFullYear()} ©️ 小兵速帮
      </div> */}
    </div>
  );
};
